"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchLimits = fetchLimits;

var _immutable = _interopRequireDefault(require("immutable"));

var _hubspot = _interopRequireDefault(require("hubspot.PortalIdParser"));

var _apiClient = _interopRequireDefault(require("hub-http/clients/apiClient"));

var BASE_URI = 'filemanager/api/v3/limits';

function fetchLimits() {
  var httpClient = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _apiClient.default;
  var earlyRequesterPromise = arguments.length > 1 ? arguments[1] : undefined;
  var promise = earlyRequesterPromise || httpClient.get(BASE_URI, {
    query: {
      portalId: _hubspot.default.get()
    }
  });
  return promise.then(_immutable.default.fromJS).catch(function () {//do nothing
  });
}